var _style, _g, _g2, _g3, _g4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116.3 126.9",
    style: {
      enableBackground: "new 0 0 116.3 126.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;stroke:#000000;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st4{display:inline;}\r\n\t.st5{fill:none;stroke:#F1F2F2;stroke-width:6;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3,
    className: "st1",
    width: 129,
    height: 126
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.5,98.8V8.2c0-0.9,0.8-1.7,1.7-1.7h73.4c0.9,0,1.7,0.8,1.7,1.7v89.7c0,0.9-0.7,1.7-1.7,1.7l-73.4,1 C8.3,100.5,7.5,99.7,7.5,98.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24,100l59,10c1.1,0.2,0.8,0.1,1-1l13.8-89.6c0.1-0.8-0.5-1.6-1.3-1.7L83,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20,100l60.4,22.4c0.9,0.4,1.9-2.1,2.2-3C93.1,90.2,101.5,64.1,112,35c0.2-0.3-1.7-0.7-2-1 c-4.7-1.7-9.3-3.3-14-5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 19.1,
    y1: 35,
    x2: 74.5,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 47.7,
    y1: 21,
    x2: 73.6,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 19.1,
    y1: 50,
    x2: 74.5,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 19.1,
    y1: 65,
    x2: 74.5,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 19.1,
    y1: 80,
    x2: 74.5,
    y2: 80
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8,96.1V4.4c0-0.9,0.8-1.7,1.7-1.7h74.2c0.9,0,1.7,0.8,1.7,1.7v90.7c0,0.9-0.7,1.7-1.7,1.7l-74.2,1 C8.8,97.8,8,97,8,96.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.1,97.7l66.9,16.2c1.1,0.3,2.2-0.4,2.5-1.5l20-90.9c0.2-0.8-0.3-1.7-1.2-1.9l-25.3-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97,80.5l27.4-33.2c0.2-0.3,0.2-0.8-0.1-1.1l-16.4-14.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.8,79c-7,0-7-2-14-2c-7,0-7,2-14,2c-7,0-7-2-14-2s-7,2-14,2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.8,60.3c-7,0-7-2-14-2c-7,0-7,2-14,2c-7,0-7-2-14-2s-7,2-14,2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.8,41.5c-7,0-7-2-14-2c-7,0-7,2-14,2c-7,0-7-2-14-2s-7,2-14,2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-nan-nan"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-nan-nan"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.7,23.3c-6.7,0-6.7-2-13.3-2c-6.7,0-6.7,2-13.3,2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st0"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    className: "st4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    className: "st4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131.9,14.8L109,9.9l0.8,84.1l-65.6-1.9l68.2,13.7c0.9,0.2,1.8-0.4,2-1.3l18.8-87.7 C133.4,15.9,132.8,15,131.9,14.8z"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 2520,
    height: 2960,
    xlinkHref: "Document - cleaned.png",
    transform: "matrix(3.968254e-02 0 0 4.020270e-02 13 5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.aa5aeb817cfe1ee79f0245db11ab526f.svg";
export { ForwardRef as ReactComponent };